module.exports = __webpack_public_path__ + "static/media/info-icon.16051b6d.svg";